import backlinkApi from './backlinkNewApi';

export const backlinkBacklinksApi = backlinkApi.injectEndpoints({
  endpoints: build => ({
    getNumOfBacklinksPerMonth: build.query({
      query: body => ({
        url: '/api_backlink/v1/backlinks/chart/num_of_backlinks_per_month',
        method: 'POST',
        body: body
      })
    }),
    getBacklinksCount: build.query({
      query: body => ({
        url: '/api_backlink/v1/backlinks/',
        method: 'POST',
        body: body
      }),
      providesTags: ['BACKLINKS']
    }),
    getBacklinks: build.mutation({
      query: body => ({
        url: '/api_backlink/v1/backlinks/',
        method: 'POST',
        body: body
      })
    })
  }),
  overrideExisting: true
});

export const {
  useGetNumOfBacklinksPerMonthQuery,
  useGetBacklinksCountQuery,
  useLazyGetBacklinksCountQuery,
  useGetBacklinksMutation
} = backlinkBacklinksApi;
export default backlinkBacklinksApi;
